var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26651_20963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8787 6.5459C16.5825 6.5459 15.8584 7.85498 16.1534 8.8277L12.9799 12.064C12.7117 11.9822 12.3184 11.9822 12.0502 12.064L9.7707 9.74588C10.0746 8.77316 9.35055 7.45498 8.04541 7.45498C6.7492 7.45498 6.01618 8.76407 6.32012 9.74588L2.24378 13.8822C1.28727 13.5822 0 14.3186 0 15.6368C0 16.6368 0.804541 17.4549 1.78787 17.4549C3.08407 17.4549 3.80816 16.1458 3.51316 15.1731L7.58056 11.0277C7.84874 11.1095 8.24208 11.1095 8.51026 11.0277L10.7898 13.3459C10.4859 14.3186 11.2099 15.6368 12.5151 15.6368C13.8113 15.6368 14.5443 14.3277 14.2404 13.3459L17.4228 10.1186C18.3793 10.4186 19.6666 9.68224 19.6666 8.36407C19.6666 7.36408 18.862 6.5459 17.8787 6.5459Z",
    fill: "#CC2364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2916 7.5L13.0619 5.775L14.7499 5L13.0619 4.225L12.2916 2.5L11.5377 4.225L9.83325 5L11.5377 5.775L12.2916 7.5Z",
    fill: "#CC2364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.86795 9.16667L3.27767 7.5L4.91656 7.08333L3.27767 6.66667L2.86795 5L2.45822 6.66667L0.819336 7.08333L2.45822 7.5L2.86795 9.16667Z",
    fill: "#CC2364"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26651_20963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6667,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendsIcon);
export default __webpack_public_path__ + "static/media/trends-icon.f7ff0b94.svg";
export { ForwardRef as ReactComponent };